(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    // SUPPORTING MODEL
    // This model represents an Electronic Address
    function ElectronicAddressViewModel() {

        // Self-Identification
        var self = this;
        self.hideDoNotContact = ko.observable(false);
        self.hideEffectiveLabelDisplay = ko.observable(false);
        sm.portal.vm.custom.setCustomLocalizeKey(self);

        this.LoadModel = function (container) {
            if (container.Payload.ListData) {
                ko.mapping.fromJS(container.Payload.ListData.EAddressTypeEntries, {}, this.TypeEntries);
                ko.mapping.fromJS(container.Payload.ListData.DoNotContactReasons, {}, this.DoNotContactReasons);
                ko.mapping.fromJS(container.Payload.ListData.AddressTimings, {}, this.AddressTimings);
                ko.mapping.fromJS(container.Payload.ListData.ElectronicAddressAssociations, {}, this.Associations);
            }
        };
        this.LoadElectronicAddressModel = function (container) {
            if (!container || !container.AssociationIDs) {
                if (this.me) {
                    container = this.me;
                }
            }

            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var electronicAddressEffectiveFrom = container.EffectiveFrom ? moment(container.EffectiveFrom).format(dateFormat) : '';
            var electronicAddressEffectiveTo = container.EffectiveTo ? moment(container.EffectiveTo).format(dateFormat) : '';

            this.me = container;
            this.ID(container.ID);
            this.Value(container.Value);
            this.TypeEntryID(container.TypeEntryID);
            this.EffectiveFrom(electronicAddressEffectiveFrom);
            this.EffectiveTo(electronicAddressEffectiveTo);
            this.AddressTypeID(container.AddressTypeID);
            this.AddressTimingTypeID(container.AddressTimingTypeID);
            this.DoNotContact(container.DoNotContact);
            this.NoContactReasonID(container.NoContactReasonID);

            this.AssociationIDs.removeAll();
            for (var i = 0; i < container.AssociationIDs.length; i++) {
                this.AssociationIDs.push(container.AssociationIDs[i].toString());
            }

            this.AssociationNames.removeAll();
            for (var i = 0; i < container.AssociationNames.length; i++) {
                this.AssociationNames.push(container.AssociationNames[i]);
            }

            this.TypeEntryName(container.TypeEntryName);
            this.TypeEntryBusinessMeaningName(container.TypeEntryBusinessMeaningName);
            this.AddressTimingTypeName(container.AddressTimingTypeName);
            this.DoNotContactReasonName(container.DoNotContactReasonName);
        };

        this.ID = ko.validatedObservable();
        this.Value = ko.validatedObservable();
        this.TypeEntryID = ko.validatedObservable();
        this.TypeEntryName = ko.validatedObservable();
        this.TypeEntryBusinessMeaningName = ko.validatedObservable();
        this.EffectiveFrom = ko.validatedObservable();
        this.EffectiveTo = ko.validatedObservable();
        this.AddressTypeID = ko.validatedObservable();
        this.AddressTypeName = ko.validatedObservable();
        this.AddressTimingTypeID = ko.validatedObservable();
        this.AddressTimingTypeName = ko.validatedObservable();
        this.DoNotContact = ko.validatedObservable();
        this.NoContactReasonID = ko.validatedObservable();
        this.DoNotContactReasonName = ko.validatedObservable();
        this.AssociationIDs = ko.observableArray();
        this.AssociationNames = ko.observableArray();

        this.TypeEntryIconName = ko.computed(function () {
            var iconClass = 'icon ' + this.TypeEntryName() + 'MessageIcon';
            return iconClass;
        }, this);

        this.TypeEntries = ko.observableArray([new smapi.access.ListItemModel()]);
        this.Associations = ko.observableArray([new smapi.access.ListItemModel()]);
        this.DoNotContactReasons = ko.observableArray([new smapi.access.ListItemModel()]);
        this.AddressTimings = ko.observableArray([new smapi.access.ListItemModel()]);

        this.EffectiveLabelDisplay = ko.computed(function () {

            if (sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                return sm.portal.utility.getResourceValue('EffectiveTill'); 
            }
            return sm.portal.utility.getResourceValue('EffectiveFrom'); 

        }, this);

        this.EffectiveDisplay = ko.computed(function () {
            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            
            if (!sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                // Return full FROM..TO.. string
                return this.EffectiveFrom() + " to " + this.EffectiveTo();
            } else if (!sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                // Return FROM...
                return this.EffectiveFrom();
            } else if (sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                return this.EffectiveTo();
            }
            return "";

        }, this);

        this.DoNotContactAsYesNo = ko.computed(function () {
            if (this.DoNotContact()) {
                return sm.portal.utility.getResourceValue('Yes'); 
            }
            return sm.portal.utility.getResourceValue('No');
        }, this);
        this.AssociationDisplay = ko.computed(function () {

            var display = '';
            for (var i = 0; i < this.AssociationNames().length; i++) {
                if (display == '') {
                    display = this.AssociationNames()[i];
                } else {
                    display += ', ' + this.AssociationNames()[i];
                }
            }
            return display;

        }, this);

        self.isCustomized = sm.portal.vm.custom.callCustomization(
            "ShowEditButtonForCustomEnvironment"
        );

        sm.portal.vm.custom.callCustomization('UpdateElectronicAddressProps', self);

        this.ExtractATO = function () {

            var submitAddressObject = ko.mapping.toJS(this);

            var electronicAddressEffectiveFrom = submitAddressObject.EffectiveFrom ? moment(submitAddressObject.EffectiveFrom, sm.resources.portalResource.getValue('DateFormatExample').toUpperCase()).format("MM/DD/YYYY") : '';
            var electronicAddressEffectiveTo = submitAddressObject.EffectiveTo ? moment(submitAddressObject.EffectiveTo, sm.resources.portalResource.getValue('DateFormatExample').toUpperCase()).format("MM/DD/YYYY") : '';

            var assocIDs = Array();
            for (var i = 0; i < submitAddressObject.AssociationIDs.length; i++) {
                assocIDs.push(submitAddressObject.AssociationIDs[i]);
            }

            var data = {

                ID: submitAddressObject.ID,
                Value: submitAddressObject.Value,
                TypeEntryID: submitAddressObject.TypeEntryID,
                EffectiveFrom: electronicAddressEffectiveFrom,
                EffectiveTo: electronicAddressEffectiveTo,
                AddressTypeID: submitAddressObject.AddressTypeID,
                AddressTimingTypeID: submitAddressObject.AddressTimingTypeID,
                DoNotContact: submitAddressObject.DoNotContact,
                NoContactReasonID: submitAddressObject.NoContactReasonID,
                AssociationIDs: assocIDs
            };

            return data;
        };
        this.Reset = function () {
            this.ID(0);
            this.Value('');
            this.TypeEntryID(undefined);
            this.EffectiveFrom('');
            this.EffectiveTo('');
            this.AddressTypeID(undefined);
            this.AddressTimingTypeID(undefined);
            this.DoNotContact(false);
            this.NoContactReasonID(undefined);

            this.TypeEntryName('');
            this.AddressTimingTypeName('');
            this.DoNotContactReasonName('');
        };

        sm.portal.vm.custom.callCustomization('UpdateValidationsElectronicAddress', self);
        /*** VALIDATION METHODS ***/
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            email: {
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'Example@domain.com')
            },
            //TODO Add in Validation based on type
            //pattern: {
            //    params: regex,
            //    message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'XXX')
            //},
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.TypeEntryID.extend({
            min: {
                params: 1,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TypeEntryName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.TypeEntryBusinessMeaningName.extend({
            maxLength: {
                params: 80,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '80')
            }
        });
        if(sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization('DisableDateValidation'))) {
            this.EffectiveFrom.extend({
                smLocalDate: {
                    params: true,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
                },
                smValidateEffectiveFromDate: {
                    params: this.EffectiveTo,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_EffectiveBeginDate_Key)
                }
            });
            this.EffectiveTo.extend({
                smLocalDate: {
                    params: true,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
                },
                smValidateEffectiveToDate: {
                    params: this.EffectiveFrom,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_EffectiveEndDate_Key)
                }
            });
        } else {
            this.EffectiveFrom.extend({
                smLocalDate: {
                    params: true,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
                }
            });
            this.EffectiveTo.extend({
                smLocalDate: {
                    params: true,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
                }
            });
        }
        this.AddressTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AddressTypeName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.AddressTimingTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AddressTimingTypeName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.NoContactReasonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DoNotContactReasonName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        /*** VALIDATION METHODS ***/

        return self;
    }

    jQuery.extend(true, sm.portal.vm, {
        ElectronicAddressViewModel: ElectronicAddressViewModel
    });

})(jQuery);